import { render, staticRenderFns } from "./PeixesAquiculturaInstitucional.vue?vue&type=template&id=9fb417cc&"
import script from "./PeixesAquiculturaInstitucional.vue?vue&type=script&lang=js&"
export * from "./PeixesAquiculturaInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports